export enum UserStatus {
	New = "NEW",
	OnBoarding = "ONBOARDING",
	Active = "ACTIVE"
}
